module.exports = __webpack_public_path__ + "img/1559782360.a0646a9b.jpg";